const faq = {
  slack: [
    {
      id: 1,
      Question: 'What is Stripe? How are payments made?',
      Answer:
        "Stripe is the payment processing platform used by Trivia. Any payment for Trivia's subscription from our users is processed and collected through Stripe. Payments are automatically collected by Stripe every month via the credit card filled in by users while purchasing their subscription."
    },
    {
      id: 2,
      Question: 'What is an active user?',
      Answer:
        'An active user is any user who interacts or engages with Trivia. Basically an active user is anyone who: - Plays a Trivia Game, - Gets paired via VirtualCoffee, - Responds to Know Your Team questions If a member in your team makes any of the above actions, they will be regarded as an active user.'
    },
    {
      id: 3,
      Question: 'How will the monthly bill be calculated?',
      Answer:
        "You will be billed based on the total number of users in the channel(s) where Trivia is enabled.If a channel has 50 members, billing will be for all 50 members, regardless of how many actually participate in Games or features like Know Your Team, Celebrations, or Virtual Coffee during the month.If Trivia is enabled in multiple channels (e.g., 2 channels), each user will only be billed once, even if they are part of multiple channels. This is unique user billing. Minimum billable users: 29 for the Standard Plan, 49 for the Pro Plan."
    },
    {
      id: 4,
      Question: 'How to get customer support?',
      Answer:
        'Write to us via mail at <a href="support@heronhr.co" target="blank">support@heronhr.co.</a> - Open your Trivia Dashboard and click on the Contact Us button present at the top right. - Open Trivia on Slack -> Click on Messages -> Type and send Help -> Choose Help & feedback button.'
    }
  ],
  teams: [
    {
      id: 1,
      Question: 'How are payments made?',
      Answer:
        'Our billing is deeply integrated with Microsoft Billing. This means you will now be billed for Trivia on the same payment method used by your organization to pay for all Microsoft services.'
    },
    {
      id: 2,
      Question: 'How do Licenses work? What do I get per License?',
      Answer:
        'You can buy Licenses from either of the plAnswer for the number of teammates you want to grant Trivia access to. Each License can be given to only one user and only those with Licenses will be able to play & engage with Trivia. The admins will have the ability to assign and unassign Licenses at any point from the total number of available Licenses.'
    },
    {
      id: 3,
      Question: 'How will the monthly bill be calculated?',
      Answer:
        'You will only be charged monthly/annually based on the number of Licenses you have bought. Admins will be allowed to buy more or deactivate Licenses which will be reflected in the bill amount.  Minimum number of licenses: 29 for the Standard Plan, 49 for the Pro Plan'
    },
    {
      id: 4,
      Question: 'How to get customer support?',
      Answer:
        "Need help? Write to us at <a href='support@heronhr.co' target='blank'>support@heronhr.co</a> or start a chat with us <a href='https://trytrivia.co/' target='blank'>here</a>.Or grab a cup of coffee and <a href='https://api-trivia-teams.trytrivia.co/demo' target='blank'>let's connect 1v1.</a>✌️"
    }
  ]
};

export default faq;
